import { PrismicImageProps, PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_TESTIMONIAL = 'PrismicGenericTemplateDataBodyTestimonial';

export interface GenericTestimonialPrimary {
  button_link: PrismicLink;
  heading: TextFromRichText;
  logo: PrismicImageProps;
  subtitle: TextFromRichText;
  variant: 'white' | 'grey';
}

export interface GenericTestimonialField {
  text: TextFromRichText;
  date: string;
  location: TextFromRichText;
  author: TextFromRichText;
  review_title: TextFromRichText;
}

export interface GenericTestimonialContent {
  __typename: typeof GENERIC_TESTIMONIAL;
  items: GenericTestimonialField[];
  primary: GenericTestimonialPrimary;
}
